import { LaunchpadLink } from "src/model/launchpad";

export default function LaunchpadLinks(props: {
  links: LaunchpadLink[]
}) {
  const sortedLinks = [...props.links].sort((a, b) => a.sortIndex - b.sortIndex);

  return <div className="w-full px-4 pt-2 flex flex-col gap-2">
    {sortedLinks.map((link) => <div key={link.url} className="rounded-full bg-accent p-2 text-center text-white font-medium">
      <a href={link.url} target="_blank" rel="noopener noreferrer">
        {link.name}
      </a>
    </div>)}
  </div>
}